import Icon from '../components/Icon.vue'

Icon.register({
  'network-wired': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 264V248C640 239.2 632.8 232 624 232H344V192H416C433.7 192 448 177.7 448 160V32C448 14.3 433.7 0 416 0H224C206.3 0 192 14.3 192 32V160C192 177.7 206.3 192 224 192H296V232H16C7.2 232 0 239.2 0 248V264C0 272.8 7.2 280 16 280H120V320H64C46.3 320 32 334.3 32 352V480C32 497.7 46.3 512 64 512H224C241.7 512 256 497.7 256 480V352C256 334.3 241.7 320 224 320H168V280H472V320H416C398.3 320 384 334.3 384 352V480C384 497.7 398.3 512 416 512H576C593.7 512 608 497.7 608 480V352C608 334.3 593.7 320 576 320H520V280H624C632.8 280 640 272.8 640 264zM256 128V64H384V128H256zM192 448H96V384H192V448zM544 448H448V384H544V448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/network-wired.js
// module id = jpmi
// module chunks = 144